export class MessageHub {
    message: any;
    type: string;
    error?: string;

    public constructor(init?: Partial<MessageHub>) {
        Object.assign(this, init);
    }
}